module.exports = __webpack_public_path__ + "static/media/cvs-icon.cfd880e9.svg";